import { createMetricInstance } from "@/metrics/registry"
import type { MetricRecord } from "@/metrics/runtime"

import type { MetricRecordData } from "@/types/metrics/contracts"

export function hydrateMetricRecord(data: MetricRecordData): MetricRecord {
  return createMetricInstance(data)
}
